/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Type1FareInfosServices } from './type1FareInfosServices';

/**
 * 運賃情報
 */
export interface Type1FareInfos {
  /**
   * FareBasis
   */
  fareClass?: string;
  /**
   * FareFamily
   */
  fareFamilyCode?: string;
  /**
   * Fare FamilyのPriority Code<br/> ※カート取得APIにおいて設定する場合、Fare Family Codeの下4桁を設定する。<br/> ※PNR情報取得APIにおいて設定する場合、DxAPIのFare Family Codeに設定されるBrand Codeをもとに、ASWDB(マスタ)から取得したPriority Codeを設定する。
   */
  priorityCode?: string;
  /**
   * Fare Familyのキャビンクラス ※Fare Family Codeの下4桁に紐づく、ASWDB(マスタ)のFF Priority Codeに定義されているCabin Classを返却する
   */
  fareCabinClass?: string;
  /**
   * 運賃種別</br> 日本国内線セグメントの場合のみ返却する。</br> 返却値は以下の通り判定する。</br> disabilityDiscount：Ticket designatorに設定ファイルに定義した障がい者割引運賃Ticket designatorが含まれている</br> ※複雑空席照会APIにおいて設定する場合、リクエストから取得した「運賃オプション」がASWDB(マスタ)のCommercial Fare Familyテーブルの項目「運賃オプションタイプ」の障がい者割引の設定値と同じ場合に設定する。</br> islandTicket：Fare Basisの7桁目が設定ファイルにて管理するアイきっぷ運賃と一致する</br> shareholdersBenefitDiscount：Fare Basisの7桁目が設定ファイルにて管理する株主優待割引運賃、または後日回収型株主優待運賃と一致する</br> businessKippu：Fare Basisの7桁目が設定ファイルにて管理するビジネスきっぷ運賃と一致する</br> other：上記のいずれにも当てはまらない</br> </br> ※Fare Basisにて判定する国内運賃（アイきっぷ運賃、株主優待割引運賃、後日回収型株主優待運賃、ビジネスきっぷ運賃）については、</br> 以下全ての条件に合致する場合に判定する。</br> 1.特典PNR区分がfalse</br> 2.旅程区分が日本国内単独旅程(domestic)である</br> 3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である
   */
  fareType?: Type1FareInfos.FareTypeEnum;
  services?: Type1FareInfosServices;
  /**
   * 特典種別</br> 特典PNRの場合のみ返却する。</br> nhInt：NH特典(国際線)。Fare Basisの末尾がNH特典(国際線)のもの(設定ファイルに定義)</br> dom：NH特典(国内線)。Fare Basisの末尾がNH特典(国内線)のもの(設定ファイルに定義)</br> starAlliance：スターアライアンス提携特典。Fare Basisの末尾が\"ST\"、\"STC\"または\"ST2\"</br> otherAirline：単一提携航空会社特典。上記以外。
   */
  awardType?: Type1FareInfos.AwardTypeEnum;
  /**
   * DxAPIから返却されたTicket Designator<br/> ※搭乗者が複数存在する場合、DxAPIから運賃情報(fareInfos)が搭乗毎に返却されるが、その場合は該当セグメントの1件目の運賃情報のticketDesignatorを設定する。
   */
  ticketDesignator?: string;
}
export namespace Type1FareInfos {
  export type FareTypeEnum =
    | 'disabilityDiscount'
    | 'islandTicket'
    | 'shareholdersBenefitDiscount'
    | 'businessKippu'
    | 'other';
  export const FareTypeEnum = {
    DisabilityDiscount: 'disabilityDiscount' as FareTypeEnum,
    IslandTicket: 'islandTicket' as FareTypeEnum,
    ShareholdersBenefitDiscount: 'shareholdersBenefitDiscount' as FareTypeEnum,
    BusinessKippu: 'businessKippu' as FareTypeEnum,
    Other: 'other' as FareTypeEnum,
  };
  export type AwardTypeEnum = 'nhInt' | 'dom' | 'starAlliance' | 'otherAirline';
  export const AwardTypeEnum = {
    NhInt: 'nhInt' as AwardTypeEnum,
    Dom: 'dom' as AwardTypeEnum,
    StarAlliance: 'starAlliance' as AwardTypeEnum,
    OtherAirline: 'otherAirline' as AwardTypeEnum,
  };
}
